import {
  BookmarksTeamBacklog,
  BookmarksWorkflowBoard,
  Iteration,
  Project,
  type Feature,
  type Requirement,
} from 'components/framework/models';
import type { HasRecordPositions } from 'components/framework/models/concerns/HasRecordPositions';
import RecordAction from '../RecordAction';
import type ApplicationModel from 'components/framework/ApplicationModel';

type Record = (Feature | Requirement) & HasRecordPositions;

export class RemoveFromPrioritizedBacklogAction extends RecordAction<Record> {
  recordTypes = ['Feature', 'Requirement'];

  get title() {
    return 'Remove from prioritized backlog';
  }

  showForRecord(record: ApplicationModel): record is Record {
    const baseCheck =
      super.showForRecord(record) &&
      window.currentProject?.backlogManagementEnabled &&
      window.currentProject?.isTeam &&
      record.team?.id;

    if (!baseCheck) {
      return false;
    }

    const iterationsEnabled = window.currentProject?.iterationsEnabled;
    const hasTeamBacklogPosition = record.recordPosition(
      BookmarksTeamBacklog.bookmarkName
    );
    const hasWorkflowBoardPosition = record.recordPosition(
      BookmarksWorkflowBoard.bookmarkName
    );

    if (iterationsEnabled) {
      return hasTeamBacklogPosition && !record.iteration;
    }

    return hasTeamBacklogPosition && !hasWorkflowBoardPosition;
  }

  async runForRecords(records: Record[]) {
    if (!window.currentProject?.id) {
      return;
    }

    const project = await Project.select('backlogBookmarkId').find(
      window.currentProject?.id
    );

    if (!project) {
      return;
    }

    await Promise.all(
      records.map(async record => {
        await record.removeRecordPosition({
          bookmarkType: BookmarksTeamBacklog.bookmarkName,
          bookmarkId: project.backlogBookmarkId as RecordId,
          secondaryScopeId: project.backlogBookmarkId as RecordId,
        });

        return record.update(
          { iteration: Iteration.blank() },
          { args: { __reactivelyUpdate: true } }
        );
      })
    );
  }
}
